// Menu travado pela pendência de report (board v4-pendencias): com `account/IS_REPORT_LOCKED`, todo item do menu —
// exceto "Compromissos", que leva à central de pendências — mostra um cadeado e não navega. O guard de rotas e o
// servidor (423) continuam sendo a trava de verdade; aqui é só o reflexo visual. Sem trava, nada muda no menu.
import { IS_REPORT_LOCKED } from '@/modules/account/store/types'
import { APPOINTMENTS_ROUTE, NEW_COPY, REPORT_HUB_ROUTE } from '@/constants/appointment_report_v2'

// Rotas que continuam no menu com a trava ("Compromissos" → o guard leva à central).
const ROUTES_ALLOWED_WHILE_REPORT_LOCKED = [APPOINTMENTS_ROUTE, REPORT_HUB_ROUTE]

const routeNameOf = item => {
  const route = item && item.route
  if (typeof route === 'string') return route
  return route && typeof route === 'object' ? route.name : undefined
}

/** O item (num grupo: algum filho, em qualquer nível) continua liberado com a trava de report. */
export function isNavItemAllowedWhileReportLocked(item) {
  if (!item) return false
  if (Array.isArray(item.children)) return item.children.some(isNavItemAllowedWhileReportLocked)

  return ROUTES_ALLOWED_WHILE_REPORT_LOCKED.includes(routeNameOf(item))
}

// Usado pelos componentes de link e de grupo (ambos recebem a prop `item`).
export default {
  computed: {
    isNavReportLocked() {
      return !!this.$store.getters[IS_REPORT_LOCKED] && !isNavItemAllowedWhileReportLocked(this.item)
    },
    navReportLockedHint() {
      return this.isNavReportLocked ? NEW_COPY.menuLockedCaption : null
    },
  },
}
